// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayPage_TitleBox__Wd6rd {
  background-color: #e8f0f1;
  color: #333;
}

.DayPage_BreakTitle__cUpK4 {
  border-top: 10px solid #e8f0f1;
}

.DayPage_TitleBox2__bZdWL {
  border-right : 2px solid #fafafa;
  color: #333;
}

.DayPage_SubTitle__yucjY {
  background-color: #e8f0f1;
}

.DayPage_Bold__NBDTB { 
  font-weight: 700;
}

.DayPage_SearchBar__z-hzX input {
    border-radius: 20px;
    color: #242a3d;
    padding-left: 40px;
    margin-bottom: 16px;
  }
  
  .DayPage_SearchIcon__7b4Zg {
    position: absolute;
    font-size: 1.2rem;
    padding: 9px;
    padding-left: 15px;
  }
  
  .DayPage_SearchIcon__7b4Zg:hover {
    cursor: default;
    color: #cfced3;
  }

  .DayPage_Edit__xqBZO {
    color: #fff;
  }

  .DayPage_Edit__xqBZO:hover {
    color: #fff;
  }

  .DayPage_Action__Rr3Mb {
    font-size: 1rem;
  }
  
  .DayPage_Italics__eITzQ {
    font-style: italic;
  }

  .DayPage_Header__SX47Q {
    background-color: #fff;
  }

  .DayPage_Div50__SRoTm {
    height: 50px;
    overflow: hidden;
  }

  .DayPage_Div25__Mxdgt {
    height: 25px;
    overflow: hidden;
  }

  @media screen and (max-width: 600px) {
    .DayPage_Title__AMRzh {
      font-size: .75em;
    }

    .DayPage_Titledetail__vGJ30 {
      font-size: 1.25em;
    }

    .DayPage_Titlelist__a8q28 {
      font-size: 1.25em;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/DayPage.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;EACF","sourcesContent":[".TitleBox {\n  background-color: #e8f0f1;\n  color: #333;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.TitleBox2 {\n  border-right : 2px solid #fafafa;\n  color: #333;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n}\n\n.Bold { \n  font-weight: 700;\n}\n\n.SearchBar input {\n    border-radius: 20px;\n    color: #242a3d;\n    padding-left: 40px;\n    margin-bottom: 16px;\n  }\n  \n  .SearchIcon {\n    position: absolute;\n    font-size: 1.2rem;\n    padding: 9px;\n    padding-left: 15px;\n  }\n  \n  .SearchIcon:hover {\n    cursor: default;\n    color: #cfced3;\n  }\n\n  .Edit {\n    color: #fff;\n  }\n\n  .Edit:hover {\n    color: #fff;\n  }\n\n  .Action {\n    font-size: 1rem;\n  }\n  \n  .Italics {\n    font-style: italic;\n  }\n\n  .Header {\n    background-color: #fff;\n  }\n\n  .Div50 {\n    height: 50px;\n    overflow: hidden;\n  }\n\n  .Div25 {\n    height: 25px;\n    overflow: hidden;\n  }\n\n  @media screen and (max-width: 600px) {\n    .Title {\n      font-size: .75em;\n    }\n\n    .Titledetail {\n      font-size: 1.25em;\n    }\n\n    .Titlelist {\n      font-size: 1.25em;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TitleBox": `DayPage_TitleBox__Wd6rd`,
	"BreakTitle": `DayPage_BreakTitle__cUpK4`,
	"TitleBox2": `DayPage_TitleBox2__bZdWL`,
	"SubTitle": `DayPage_SubTitle__yucjY`,
	"Bold": `DayPage_Bold__NBDTB`,
	"SearchBar": `DayPage_SearchBar__z-hzX`,
	"SearchIcon": `DayPage_SearchIcon__7b4Zg`,
	"Edit": `DayPage_Edit__xqBZO`,
	"Action": `DayPage_Action__Rr3Mb`,
	"Italics": `DayPage_Italics__eITzQ`,
	"Header": `DayPage_Header__SX47Q`,
	"Div50": `DayPage_Div50__SRoTm`,
	"Div25": `DayPage_Div25__Mxdgt`,
	"Title": `DayPage_Title__AMRzh`,
	"Titledetail": `DayPage_Titledetail__vGJ30`,
	"Titlelist": `DayPage_Titlelist__a8q28`
};
export default ___CSS_LOADER_EXPORT___;
